export default {
    Email: 'E-mail',
    ConfirmEmail: 'Conferma E-mail',
    Password: 'Password',
    Verificationcode: 'Codice di verifica',
    AlreadyhaveaHitPawaccountLogin: 'Hai già un account HitPaw? Accedi',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        "Registrandoti, accetti i nostri Servizi d'uso e Politica sulla privacy",
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'Effettuando il login, accetti il nostro uso dei servizi e la politica sulla privacy',
    Byproceedingyouagreetoour: 'Registrandoti/Effettuando il login, accetti i nostri ',
    ServicesofUse: "Servizi d'uso",
    and: ' e ',
    PrivacyPolicy: 'Politica sulla privacy',
    last: '.',
    TheEmailformatisincorrect: "Il formato dell'e-mail non è corretto",
    Pleaseenterthesameemailinbothfields: 'Inserisci la stessa email in entrambi i campi.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'La password deve essere di 8-50 caratteri e contenere almeno due categorie tra le seguenti: numero, lettera o carattere speciale.',
    Incorrectverificationcode: 'Codice di verifica errato',
    ThisEmailhasbeenregisteredpleasechooseanother:
        "Questa e-mail è stata registrata, scegline un'altra.",
    Cannotbeemptyhere: 'Non può essere vuoto qui.',
    Rememberme: 'Ricordati di me',
    ForgotPassword1: 'Ha dimenticato la password?',
    NotaregistereduseryetSignUp: 'Non sei ancora registrato? Registra',
    Notaregistereduseryet1: 'Non sei ancora registrato? ',
    Notaregistereduseryet2: 'Registra',
    NoaccountfoundwiththatEmailaddress: "Nessun account trovato con quell'indirizzo e-mail",
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Il tuo indirizzo e-mail o la password non erano corretti. Per favore riprova.',
    ForgotPassword2: 'Ha dimenticato la password',
    GetVerificationCode: 'Ottieni codice di verifica',
    VerifyEmail: 'Verifica E-mail',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'È stato inviato alla tua casella di posta, controllalo',
    PleaseinputEmailaddress: "Si prega di inserire l'indirizzo e-mail",
    TheEmailisnotregistered: "L'e-mail non è stata registrata",
    Invalidverificationcodepleasereenterthecorrectone:
        'Codice di verifica non valido, reinserisci quello corretto',
    Resetpassword: 'Resetta la password',
    Emailaddressverificationsucceeded: "La verifica dell'indirizzo e-mail è riuscita",
    Pleaseresetyourpassword: 'Si prega di reimpostare la password',
    Enteranewpassword: 'Inserisci una nuova password',
    Confirm: 'Conferma',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'La nuova password deve essere lunga 8-50 caratteri, composta da lettere o numeri o una combinazione di lettere + numeri',
    Passwordresetsuccessfully: 'Reimpostazione della password riuscita',
    Name: 'Nome',
    GetCode: 'Ottenere codice',
    Loginsuccessful: 'Accesso riuscito',
    Loginfailed: 'Accesso fallito',
    Signupsuccessful: 'Iscrizione riuscita',
    Signupfailed: 'Iscrizione fallita',
    Getpassword: 'Ottieni password',
    Authorizationhasexpiredpleaseloginagain:
        "L'autorizzazione è scaduta, per favore accedi di nuovo.",
    Sorrysomethingwentwrongpleasetryagainlater:
        'Mi dispiace, qualcosa è andato storto, riprova più tardi.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'Troppe richieste sono state fatte in un breve periodo di tempo, per favore riprova più tardi.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'Impossibile trovare il tuo account o la password non è corretta.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'Stai cercando di accedere a una funzione a pagamento, per favore iscriviti prima.',
    Accessdeniedfortheunauthorizedrequest: 'Accesso negato per la richiesta non autorizzata.',
    Alreadyhaveaccount: "Hai gia' un conto?",
    SignUpwithemail: 'Iscriviti con e-mail',
    Securityverification: 'Verifica della sicurezza',
    Pleaseenterthecorrectemailaddress: "Inserisci l'indirizzo email corretto!",
    PleaseInputverificationCode: 'Inserisci codice di verifica!',
    Pleaseenterthesamepasswordinbothfields: 'Inserisci la stessa password in entrambi i campi!',
    or: 'o',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'La nuova password che hai inserito è la stessa della tua vecchia password. Inserisci una password diversa',
    YourpasswordwasincorrectPleasetryagain: 'La tua password è sbagliata. Per favore riprova.',
    reg400: 'Mi dispiace, qualcosa è andato storto, riprova più tardi.',
    reg400223: "L'email e il codice non corrispondono, si prega di controllare",
    reg400224: 'Il token è scaduto',
    500: 'Errore lato server!',
    Afewsecondsaway: 'A pochi secondi',
    ContinuewithGoogle: 'Continua con Google',
    ContinuewithEmail: 'Continua con E-mail',
    LoginwithEmail: 'Accedi con E-mail',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'Usa più di 8 caratteri combinando lettere, numeri e simboli (simboli di supporto:@$!%*#_~?&^)',
    ConfirmPassword: 'Conferma password',
    Pleaseloginwithemail: 'Si prega di accedere con e-mail',
    youraccount: 'Il tuo account',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        'esiste già, per garantire la sicurezza del tuo account, completa prima la verifica.',
    Login: 'Accedere',
    exceed6Times: "La tua prova è scaduta oggi, esegui l'upgrade a Pro per accedere a tutte le funzionalità premium.",
    exceed20M: "La dimensione del file per gli account gratuiti non può superare i 20 MB, esegui l'upgrade a Pro per accedere a tutte le funzionalità premium."
}